import React from 'react';
import AfterPay from './AfterPay.jsx';
import ProductGallery from './ProductGallery.jsx';
import ProductPromos from './ProductPromos.jsx';
import ProductForm from './ProductForm.jsx';
import ProductDescription from './ProductDescription.jsx';
import SizeGuide from './SizeGuide.jsx';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';
import { formatMoney } from '@shopify/theme-currency';
import ImageZoom from '../components/ImageZoom';
import MediaQuery from 'react-responsive';
import Drawer from './Drawer.jsx';

export default class Product extends React.Component {
  constructor(props) {
    super();

    const options = {
      'option1': null,
      'option2': null,
      'option3': null
    };

    if (props.defaultVariant) {
      options.option1 = props.defaultVariant.option1
      options.option2 = props.defaultVariant.option2
      options.option3 = props.defaultVariant.option3
    } else if (props.product.options.includes('Width')) {
      const widthOptionIndex = props.product.options.indexOf('Width');
      const widthOption = props.product.options_with_values[widthOptionIndex];
      const propIndex = widthOptionIndex + 1;

      if (props.url.searchParams.has('collection') && props.url.searchParams.get('collection').includes('wide-width') && widthOption.values.includes('Wide')) {
        options[`option${propIndex}`] = 'Wide';
      } else if (widthOption.values.includes('Standard')) {
        options[`option${propIndex}`] = 'Standard';
      }
    }

    this.state = {
      imageOverlay: null,
      currentVariant: props.defaultVariant, 
      ...options, 
      sizeGuideOpen: false, 
      fitGuideOpen: false, 
      intlSizeGuideOpen: false, 
      productVideoModalOpen: false,
    };

    this.productPrice = this.productPrice.bind(this);
    this.breadcrumbs = this.breadcrumbs.bind(this);
    this.sizeGuides = this.sizeGuides.bind(this);
    // this.productMediaTrigger = this.productMediaTrigger.bind(this);
    this.productVideoModal = this.productVideoModal.bind(this);
    this._colorChange = this._colorChange.bind(this);
    this._optionChange = this._optionChange.bind(this);
    this._variantChange = this._variantChange.bind(this);
    this._openSizeGuide = this._openSizeGuide.bind(this);
    this._openFitGuide = this._openFitGuide.bind(this);
    this._swapSizeGuide = this._swapSizeGuide.bind(this);
    this._openImageZoom = this._openImageZoom.bind(this);
    this._openProductVideoModal = this._openProductVideoModal.bind(this);
    window.dataLayer = window.dataLayer || [];
  }

  productPrice() {
    if (!this.state.currentVariant && this.props.product.price_varies) {
      return <p className="price">
        <span className="money">{formatMoney(this.props.product.price_min, Theme.moneyFormat)}</span> - <span className="money">{formatMoney(this.props.product.price_max, Theme.moneyFormat)}</span>
      </p>
    }
    const price = this.state.currentVariant ? this.state.currentVariant.price : this.props.product.price_min;
    const compare_price = this.state.currentVariant ? this.state.currentVariant.compare_at_price : this.props.product.compare_at_price_min;
    if (compare_price > price) {
      return <p className="price sale">
        <span className="original money">{formatMoney(compare_price, Theme.moneyFormat)}</span>
        <span className="money">{formatMoney(price, Theme.moneyFormat)}</span>
      </p>
    }
    return <p className="price">
      <span className="money">{formatMoney(price, Theme.moneyFormat)}</span>
    </p>
  }

  breadcrumbs() {
    if (this.props.breadcrumbs.length) {
      return <ul className="breadcrumb-navigation">
        {this.props.breadcrumbs.map((breadcrumb, i) => {
          return <li key={i}>
            <a href={`/collections/${breadcrumb.handle}`}>{breadcrumb.label}</a>
            <span className="sep">
              <SVG icon="arrow-thin-right" />
            </span>
          </li>
        })}
        <li>{this.props.product.title.split('|')[0]}</li>
      </ul>
    }
    return null
  }

  productVideoModal() {
    const productVideo = this.props.product.media && this.props.product.media.filter(media => media.media_type === 'video')[0]
    if (productVideo) {
      return <Drawer open={this.state.productVideoModalOpen} className={"modal"} _close={() => { this.setState({ productVideoModalOpen: false }) }} mountOnEnter={true} unmountOnExit={true}>
        <div className="product-video-container" style={{ paddingBottom: productVideo.aspect_ratio * 100 + '%' }}>
          <video loop playsInline controls autoPlay>
            {productVideo.sources.slice(0).reverse().map((source, i) =>
              <source type={source.mime_type} height={source.height} width={source.width} src={source.url} key={i} />
            )}
          </video>
        </div>
      </Drawer>
    }
    return null
  }

  sizeGuides() {
    if (this.props.sizeGuides) {
      return <React.Fragment>
        {this.props.sizeGuides.fit_guide_html ? <SizeGuide open={this.state.fitGuideOpen} content={this.props.sizeGuides.fit_guide_html} _close={() => this.setState({ fitGuideOpen: false })} mountOnEnter={false} unmountOnExit={true} /> : null}
        {this.props.sizeGuides.size_guide_html ? <SizeGuide open={this.state.sizeGuideOpen} content={this.props.sizeGuides.size_guide_html} _close={() => this.setState({ sizeGuideOpen: false })} _swapSizeGuide={this._swapSizeGuide} mountOnEnter={false} unmountOnExit={true} /> : null}
        {this.props.sizeGuides.intl_size_guide_html ? <SizeGuide open={this.state.intlSizeGuideOpen} content={this.props.sizeGuides.intl_size_guide_html} _close={() => this.setState({ intlSizeGuideOpen: false })} _swapSizeGuide={this._swapSizeGuide} mountOnEnter={false} unmountOnExit={true} /> : null}
      </React.Fragment>
    }
    return null
  }

  /* productMediaTrigger() {
    if (this.props.productVideo) {
      return <button className="product-media-trigger" onClick={this._openProductVideoModal}><SVG icon="video" />{this.props.productVideo.alt}</button>
    }
    return (null);
  } */

  _colorChange(color) {
    if (color.handle === this.props.product.handle) {
      this.setState({ imageOverlay: null })
    } else {
      this.setState({ imageOverlay: color })
      window.dataLayer.push({ 'event': 'Hover Product Thumbnails', 'product-color': color.title });
    }
  }

  _optionChange(name, value) {
    this.setState({ [name]: value }, this._variantChange);
  }

  _variantChange() {
    const currentVariant = this.props.product.variants.find(v => v.option1 === this.state.option1 && v.option2 === this.state.option2 && v.option3 === this.state.option3);
    this.setState({ currentVariant });
    if (!currentVariant) {
      return;
    }
    this.props.url.searchParams.set('variant', currentVariant.id);
    history.replaceState(currentVariant, '', this.props.url.href);
  }

  _openFitGuide(e) {
    e.preventDefault();
    this.setState({ fitGuideOpen: true })
  }

  _openSizeGuide(e) {
    e.preventDefault();
    this.setState({ sizeGuideOpen: true })
  }

  _swapSizeGuide(e) {
    e.preventDefault();
    this.setState({ intlSizeGuideOpen: this.state.sizeGuideOpen, sizeGuideOpen: this.state.intlSizeGuideOpen })
  }

  _openProductVideoModal(e) {
    e.preventDefault();
    const productVideo = this.props.product.media && this.props.product.media.filter(media => media.media_type === 'video')[0];
    if (productVideo) {
      window.heap && window.heap.track('WatchedExplainerVideo', { productTitle: this.props.product.title, productHandle: this.props.product.handle, buttonText: productVideo.alt, mediaId: productVideo.id });
      this.setState({ productVideoModalOpen: true })
    }
  }

  _openImageZoom(id, el) {
    if (!this.imageZoom) {
      const imageZoomMedia = this.props.product.media.filter(m => m.media_type !== 'video').map(src => {
        if (src.media_type === 'model') {
          return {
            "id": src.id,
            "html": `<model-viewer camera-controls="true" poster="${src.preview_image}" src="${src.sources[0].url}" data-shopify-feature="1.2" data-js-focus-visible ar-status="not-presenting"></model-viewer>`
          }
        }
        if (src.alt && src.alt.includes('mp4')) {
          return {
            "id": src.id,
            "html": `<video src=${this.props.context.productSettings.cdnUrl}${src.alt} class="pswp-video" autoplay loop playsinline muted />`
          }
        }
        return {
          "id": src.id,
          "w": src.width,
          "h": src.height,
          "src": src.src
        }
      });

      this.imageZoom = new ImageZoom(imageZoomMedia);
    }

    this.imageZoom.open(id, el);
  }

  componentDidMount() {
    window.addEventListener('fitFinder:set', e => {
      const variant = this.props.product.variants.find(v => v.id === e.detail.id);
      if (variant) {
        this.setState({ option1: variant.option1, option2: variant.option2, option3: variant.option3 }, this._variantChange)
      }
    });
  }

  render() {
    return <ProductContext.Provider value={this.props.context}>
      <div className="product-page">
        <section className="product-area">
          <div className="showcase left-main-image">
            <this.breadcrumbs />
            <ProductGallery media={this.props.product.media} tags={this.props.product.tags} productName={this.props.product.title} handle={this.props.product.handle} thumbPivot={this.props.metafields.thumbnails.pivot} overlay={this.state.imageOverlay} _openImageZoom={this._openImageZoom} _openProductVideoModal={this._openProductVideoModal} />
          </div>
          <div className={`product-details-wrapper ${this.props.product.type}`}>
            <div className="header">
              <h1 className="product-title">{this.props.product.title.split('|')[0]}</h1>
              {/* <MediaQuery maxWidth={719}>
                <this.productMediaTrigger />
              </MediaQuery> */}
            </div>
            <div className="price-header">
              <this.productPrice />
              <AfterPay productTags={this.props.product.tags} productPrice={this.props.product.price_min} />
            </div>
            <ProductPromos product={this.props.product} blocks={this.props.blocks} metafields={this.props.metafields} position="below-price" _openSizeGuide={this._openSizeGuide} _openFitGuide={this._openFitGuide} />
            <ProductForm {...this.props} currentVariant={this.state.currentVariant} option1={this.state.option1} option2={this.state.option2} option3={this.state.option3} onOptionChange={this._optionChange} onColorChange={this._colorChange} _openSizeGuide={this._openSizeGuide} _openFitGuide={this._openFitGuide} />
          </div>
        </section>
        <ProductDescription description={this.props.product.description} />
        <this.sizeGuides />
      </div>
      <this.productVideoModal />
    </ProductContext.Provider>
  }
}